// extracted by mini-css-extract-plugin
export default {"letter":"Letter_letter__3rSoB","wrong":"Letter_wrong__t89V6","correct":"Letter_correct__vgbvL","exact":"Letter_exact__5PdR-","error":"Letter_error__6-kwF"};